export default __webpack_public_path__ + "static/media/juice-fruit-product-r-tablet.4df7254b.png";